import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';
import artwork from '../../../assets/auth-artwork.webp';

interface AuthRightPanelProps {
  className?: string;
}

/**
 * The artwork half of the signed-out shell.
 *
 * The picture is the same in both themes: it is the one surface in the app
 * allowed to carry colour, and its deep bottom corner is where the copy sits.
 */
export const AuthRightPanel = ({ className }: AuthRightPanelProps) => {
  const { t } = useTranslation();
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={cn('relative size-full overflow-hidden bg-[#1b4470]', className)}>
      <img
        src={artwork}
        alt=""
        aria-hidden
        onLoad={() => setLoaded(true)}
        className={cn(
          'pointer-events-none absolute inset-0 size-full object-cover transition-opacity duration-700',
          loaded ? 'opacity-100' : 'opacity-0',
        )}
      />

      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/35 to-transparent" />

      <div className="absolute inset-x-0 bottom-0 max-w-[560px] p-10 text-white lg:p-12">
        <h2 className="font-heading text-4xl leading-[1.05] font-medium tracking-tight text-balance [text-shadow:0_1px_24px_rgb(0_0_0/0.25)] lg:text-5xl">
          {t('AUTH.PANEL.HEADLINE')}
        </h2>
        <p className="mt-4 max-w-[420px] text-[15px] leading-relaxed text-white/80">
          {t('AUTH.PANEL.SUBLINE')}
        </p>
      </div>
    </div>
  );
};
